// mui
import { makeStyles } from '@material-ui/core/styles'
import PhoneIcon from '@mui/icons-material/Phone'
import EmailIcon from '@mui/icons-material/Email'
import HomeIcon from '@mui/icons-material/Home'

// custom fields
import { Text } from '../../../1elements'
import FormikField from '../../../1elements/Fields/FormikField'

// third party libraries
import { useParams } from 'react-router-dom'
import { formatDate } from '../../../../services/util/formatter'
import AddressFieldsLine from '../../../2compounds/CompoundsFields/AddressFieldsLine'
import PersonAvatar from '../../../2compounds/PersonAvatar/PersonAvatar'
import { useContext, useEffect, useState } from 'react'
import { GlobalContext } from '../../../../services/context/DataContext'
import { placeholder } from '../../../../consts/placeholder'
import DateField from '../../../1elements/Fields/DateField'

const EditMode = ({ data, cardIndex }) => {
  const { tabName } = useParams()
  const classes = useStyles({ tabName })
  const { servicesCategorizedByServiceTypeContext } = useContext(GlobalContext)
  const [
    servicesCategorizedByServiceType,
    setServicesCategorizedByServiceType
  ] = servicesCategorizedByServiceTypeContext
  const name = fieldIndex => {
    return `values[${cardIndex}].cardData[${fieldIndex}].fieldData`
  }
  const fullName =
    tabName === 'tab1'
      ? data[0].fieldData.fullName
      : typeof data[0].fieldData === 'string'
      ? data[0].fieldData
      : ''

  const [avatar, setAvatar] = useState(data[0]?.fieldData?.avatar | '')

  const switchFieldLabel = (
    sysName,
    fieldLabel,
    fieldIndex,
    type,
    isMandatory
  ) => {
    switch (sysName) {
      case 'Field 77': // Contact Name
      case 'Field 120': // Service Name
        return null
      case 'Field 78': // Phone Number
        return <PhoneIcon className={classes.icon} style={{ fontSize: 18 }} />
      case 'Field 79': // Email Address
        return <EmailIcon className={classes.icon} style={{ fontSize: 18 }} />
      case 'Field 80': // Address
        return <HomeIcon className={`${classes.icon} ${classes.addressIcon}`} style={{ fontSize: 18 }} />
      default:
        return <Text type={'h9'}>{fieldLabel}:&nbsp;</Text>
    }
  }

  const switchFieldValue = (
    sysName,
    fieldValue,
    fieldIndex,
    type,
    isMandatory
  ) => {
    const placeHolder = placeholder[type.toLowerCase()]

    switch (sysName) {
      case 'Field 78': // Phone Number
        return (
          <FormikField
            name={name(fieldIndex)}
            placeholder={placeHolder}
            type={type}
            required={isMandatory}
          />
        )
      case 'Field 79': // Email
        return (
          <FormikField
            name={name(fieldIndex)}
            placeholder={placeHolder}
            type={type}
            required={isMandatory}
          />
        )
      case 'Field 77': // Contact Name
      case 'Field 120': // Service Name
        return null
      case 'Field 80': // Address
        return (
          <AddressFieldsLine cardIndex={cardIndex} fieldIndex={fieldIndex} />
        )
      case 'Field 81': // ID Number
        return fieldValue
      case 'Field 82': // Assigned Date
        return formatDate(fieldValue)
      default:
        if (type === 'Date')
          return (
            <DateField name={name(fieldIndex)} className={classes.textField} />
          )
        return (
          <FormikField
            name={name(fieldIndex)}
            placeholder={placeHolder}
            type={type}
            required={isMandatory}
          />
        )
    }
  }

  const onSave = (newUrl, email) => {
    setAvatar(newUrl)
    const servicesCategorizedByServiceTypeCopy = {
      ...servicesCategorizedByServiceType
    }
    const contactType = Object.keys(servicesCategorizedByServiceTypeCopy)
    for (let j = 0; j < contactType.length; j++) {
      servicesCategorizedByServiceTypeCopy[contactType[j]].forEach(person => {
        if (person.email_address === email) {
          person.avatar = newUrl
        }
      })
    }
    setServicesCategorizedByServiceType(servicesCategorizedByServiceTypeCopy)
  }

  useEffect(() => {
    setAvatar(data[0]?.fieldData?.avatar | '')
  }, [data])

  return (
    <div className={classes.root} key={cardIndex}>

      <PersonAvatar
        // currently unclear if this avatar is in use, editing temporarily disabled 
        // editMode={tabName === 'tab1'}
        editMode={false}
        name={fullName || ''}
        avatar={avatar || ''}
        // email={data[2].fieldData || ''}
        onSave={onSave}
      />
      <div className={classes.textDiv}>
        <Text type={'h10'} className={classes.serviceName}>
          {fullName || ''}
        </Text>
        <div className={classes.dataGrid}>
          {data &&
            data.map((field, fieldIndex) => {
              const {
                isArchived,
                isHidden,
                label,
                fieldData,
                sysName,
                fieldId,
                type,
                isMandatory
              } = field
              if (
                !isArchived &&
                !isHidden &&
                sysName !== 'Field 77' &&
                sysName !== 'Field 120'
              ) {
                return (
                  <div className={classes.fieldRow} key={fieldId}>
                    {switchFieldLabel(
                      sysName,
                      label,
                      fieldIndex,
                      type,
                      isMandatory
                    )}
                    <Text type={'p'}>
                      {switchFieldValue(
                        sysName,
                        fieldData,
                        fieldIndex,
                        type,
                        isMandatory
                      )}
                    </Text>
                  </div>
                )
              }
              return null
            })}
        </div>
      </div>
    </div>
  )
}

export default EditMode

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 20
  },
  serviceName: {
    // color: theme.palette.tertiary.main
  },
  textDiv: {
    marginLeft: 20,
    flexGrow: 2
  },
  dataGrid: {
    padding: 0,
    display: 'grid',
    gridTemplateRows: props =>
      props.tabName === 'tab1' ? 'repeat(3, 1fr)' : 'repeat(5, 1fr)',
    gridTemplateColumns: 'repeat(2, 1fr)',
    width: '100%',
    height: '100%'
  },
  resetToDefaultButton: {
    position: 'absolute',
    right: 40,
    top: 20,
    zIndex: 1,
    '& .MuiButtonBase-root': {
      padding: 0
    }
  },
  fieldRow: {
    display: 'flex',
    alignItems: 'center',
    margin: '2px 0'
  },
  icon: {
    marginRight: 10,
    fontSize: 18
    // color: theme.palette.primary.main
  },
  title: {
    height: 30,
    width: 300,
    margin: '5px 0'
  },
  addressIcon: {
    alignSelf: 'flex-start'
  }
}))
